'use client';
import { usePathname } from 'next/navigation';
import { Skeleton } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';
import { PATHS } from '@/config/paths';
import { WidgetContainer } from '@/components/modules/Widget/Container';
import { useGetKeepWatching } from '@/modules/Entertainment/http/client/useGetKeepWatching';
import { IfRender } from '@/utils/jsx';
import { ContentProgressCard } from '../ContentProgressCard';

export const LastViewWidget = () => {
  const pathname = usePathname();
  const t = useT();

  const { data: keepWatching = [], isLoading } = useGetKeepWatching(
    pathname === PATHS.hubs.research ? 'research' : 'home'
  );

  if (isLoading) {
    return (
      <WidgetContainer
        containerId="LastView"
        title={t('widgets.LastViewWidget.title')}
        buttonLink={PATHS.user.myHistoric}
      >
        {Array.from({ length: 10 }).map((_, idx) => (
          <Skeleton key={idx} w="24rem" h="11.25rem" borderRadius="0.5rem" />
        ))}
      </WidgetContainer>
    );
  }

  return (
    <IfRender condition={keepWatching.length > 0}>
      <WidgetContainer
        containerId="LastView"
        title={t('widgets.LastViewWidget.title')}
        buttonLink={PATHS.user.myHistoric}
      >
        {keepWatching.map(
          ({
            id,
            program_type_trans,
            published_at,
            slug,
            summary,
            thumb,
            title,
            watch,
          }) => (
            <ContentProgressCard
              key={id}
              subtitle={summary}
              description={`${published_at} • ${program_type_trans}`}
              progress={watch.percentage}
              slug={slug}
              thumbAlt={title}
              thumbUrl={thumb}
              title={title}
            />
          )
        )}
      </WidgetContainer>
    </IfRender>
  );
};
